import { render, staticRenderFns } from "./OrderPartProcessStatusChip.vue?vue&type=template&id=eb3fed22&scoped=true&"
import script from "./OrderPartProcessStatusChip.vue?vue&type=script&lang=js&"
export * from "./OrderPartProcessStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3fed22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
